// @flow

import * as React from "react";

import { type LinkType } from "../../types";

import Breadcrumbs from "../molecules/Breadcrumbs";
import { PrimaryNavPad } from "../organisms/PrimaryNav";
import TextButton from "../atoms/TextButton";

import { ReactComponent as Triangle } from "../../../assets/images/shape-triangle.svg";
import { ReactComponent as Circle } from "../../../assets/images/shape-circle.svg";
import { ReactComponent as Ring } from "../../../assets/images/shape-ring-thick-fill.svg";
import { ReactComponent as Diamond } from "../../../assets/images/shape-diamond.svg";

type PropsType = {
    theme: "purple" | "orange" | "green" | "teal" | "pink" | "red" | "blue",
    heading: string,
    description?: string,
    ctaInfo?: string,
    ctas?: [{ link: LinkType }],
};

const HeroListing = (props: PropsType): React.Node => {
    const baseClassName = "hero-listing";
    const classes = [baseClassName];
    const showInfoArea = props.ctaInfo || (props.ctas && props.ctas.length);

    if (props.theme) {
        classes.push(`${baseClassName}--${props.theme}`);
    }

    return (
        <div className={classes.join(" ")}>
            <PrimaryNavPad />

            <div className="hero-listing__container container-fluid">
                {/* Design elements */}
                <Circle className="hero-listing__circle" />
                <Ring className="hero-listing__ring" />
                <Triangle className="hero-listing__triangle" />
                <Diamond className="hero-listing__diamond" />

                <div className="hero-listing__inner">
                    <Breadcrumbs />
                    <h1 className="hero-listing__heading">{props.heading}</h1>
                    <p className="hero-listing__description">
                        {props.description}
                    </p>
                </div>
            </div>

            {showInfoArea && (
                <div className="hero-listing__info">
                    <div className="hero-listing__info__container container-fluid">
                        <div className="hero-listing__info__inner">
                            <div className="hero-listing__cta-info">
                                {props.ctaInfo}
                            </div>
                            <div className="hero-listing__ctas">
                                {props.ctas
                                    ? props.ctas.map(
                                          (cta: any, index): React.Node => {
                                              return (
                                                  <TextButton
                                                      key={index}
                                                      className="hero-listing__cta"
                                                      to={cta.cta.url}
                                                      target={cta.cta.target}
                                                  >
                                                      {cta.cta.title}
                                                  </TextButton>
                                              );
                                          }
                                      )
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

HeroListing.defaultProps = {
    theme: "pink",
};

export default HeroListing;
